import { Plugin } from 'vue';
import { install } from './plugin';
export { useAlertBox } from './alertBox';
export type { AlertBoxPluginOptions } from './types';

export default {
  install,
} as Plugin;
